import { render } from "./TransferIndex.vue?vue&type=template&id=0ed8d3f1&scoped=true"
import script from "./TransferIndex.vue?vue&type=script&lang=js"
export * from "./TransferIndex.vue?vue&type=script&lang=js"

import "./TransferIndex.vue?vue&type=style&index=0&id=0ed8d3f1&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ed8d3f1"]])

export default __exports__